import { render, staticRenderFns } from "./user-data-row.vue?vue&type=template&id=4a995f78&scoped=true"
import script from "./user-data-row.vue?vue&type=script&lang=js"
export * from "./user-data-row.vue?vue&type=script&lang=js"
import style0 from "./user-data-row.vue?vue&type=style&index=0&id=4a995f78&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a995f78",
  null
  
)

export default component.exports